import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

export type AvailabilitySeverity =
  | 'severe'
  | 'mild'
  | 'ok'
  | 'excellent'
  | 'unknown';

export interface AvailabilityTrendRow {
  outlet_id: string;
  source: 'swiggy';
  avail_7d: number | null;
  avail_28d: number | null;
  delta_7d_vs_28d: number | null;
  days_with_data_7d: number | null;
  days_with_data_28d: number | null;
  last_data_date: string | null;
  severity: AvailabilitySeverity;
}

/**
 * Per-outlet Swiggy online-availability% (last 7d avg + 28d avg + delta).
 * Drives the availability panel on /aggregators and feeds Active Fires.
 */
export function useAvailabilityTrends() {
  return useQuery({
    queryKey: ['availability-trends'],
    queryFn: async (): Promise<AvailabilityTrendRow[]> => {
      const { data, error } = await marketing
        .from('outlet_availability_trend')
        .select('*');
      if (error) throw error;
      return (data ?? []) as unknown as AvailabilityTrendRow[];
    },
    staleTime: 60_000,
  });
}
